module.exports = __webpack_public_path__ + "img/11.1f44e13a.png";